(function(window, endActionsControllerFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.endActionsController = endActionsControllerFactory(window, namespace.endActionType, namespace.playerConfiguration);
})(this, function(window, endActionType, playerConfiguration) {
   'use strict';

   var getEndActionType = function() {
      var xmpEndActionType = playerConfiguration.getEndActionType();

      if (xmpEndActionType !== undefined) {
         var xmpEndActionTypeLowerCase = xmpEndActionType.toLowerCase();
         var endActionParam = playerConfiguration.getEndActionParam();

         switch (xmpEndActionTypeLowerCase) {
            case 'loop': {
               return endActionType.loop;
            }
            case 'stop': {
               if (endActionParam === 'false' || endActionParam === '0') {
                  return endActionType.hideReplayControls;
               }
               return endActionType.showReplayControls;
            }
            case 'jumptotime': {
               return endActionType.jumpToTimeAndPlay;
            }
            case 'jumptotimeandstop': {
               return endActionType.jumpToTImeAndStop;
            }
            case 'jumptourl': {
               return endActionType.openUrl;
            }
            case 'jumptourlnew': {
               return endActionType.openUrlInNewWindow;
            }
            default: {
               return endActionType.notAvailable;
            }
         }
      }
      return endActionType.notAvailable;
   };

   var executeSeekAction = function(onReplayHandler, playAfterSeek) {
      var seekTime = parseFloat(playerConfiguration.getEndActionParam());
      var seekTimeInSeconds = !seekTime ? 0 : seekTime / 1000;
      onReplayHandler(seekTimeInSeconds, playAfterSeek);
   };

   var executeOpenLinkAction = function(inNewWindow) {
      var target = inNewWindow === true ? '_blank' : '_top';
      var urlString = '' + playerConfiguration.getEndActionParam();
      window.open(urlString, target);
   };

   var executeEndAction = function(replayVideoHandler, showReplayControlsHandler) {
      var type = getEndActionType();
      if (type === endActionType.notAvailable) {
         return;
      }

      switch (type) {
         case endActionType.loop: {
            executeSeekAction(replayVideoHandler, true);
            break;
         }
         case endActionType.jumpToTimeAndPlay: {
            executeSeekAction(replayVideoHandler, true);
            break;
         }
         case endActionType.jumpToTImeAndStop: {
            executeSeekAction(replayVideoHandler, false);
            break;
         }
         case endActionType.showReplayControls: {
            showReplayControlsHandler();
            break;
         }
         case endActionType.openUrl: {
            executeOpenLinkAction(false);
            break;
         }
         case endActionType.openUrlInNewWindow: {
            executeOpenLinkAction(true);
            break;
         }
      }
   };

   return Object.defineProperties({
      getEndActionType: getEndActionType,
      executeEndAction: executeEndAction
   }, {});
});
